import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
// locales
import { useLocales } from 'src/locales';
import { useAuthContext } from "src/auth/hooks";
import SvgColor from 'src/components/svg-color';
import { sub } from 'date-fns';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

// ----------------------------------------------------------------------

export function useNavData() {
  const { t } = useLocales();
  const menu = [
    {
        "id": 1,
        "title": "summary",
        "parent_id": 0,
        "subheader": "dashboard",
        "path": "paths.dashboard.root",
        "icon": "ic_dashboard",
        "priority": 1,
        "permission": null
    },
    {
        "id": 2,
        "title": "Notifications",
        "parent_id": 0,
        "subheader": "dashboard",
        "path": "paths.dashboard.notifications.root",
        "icon": "ic_mail",
        "priority": 2,
        "permission": null
    },
    {
        "id": 3,
        "title": "user",
        "parent_id": 0,
        "subheader": "management",
        "path": "paths.dashboard.user.root",
        "icon": "ic_user",
        "priority": 3,
        "permission": "users"
    },
    {
        "id": 16,
        "title": "organizations",
        "parent_id": 0,
        "subheader": "dashboard",
        "path": "paths.dashboard.organization.root",
        "icon": "ic_user",
        "priority": 16,
        "permission": "organizations"
    },
    {
        "id": 9,
        "title": "applications",
        "parent_id": 0,
        "subheader": "dashboard",
        "path": "paths.dashboard.applications.root",
        "icon": "ic_file",
        "priority": 9,
        "permission": "jobs"
    },
    {
        "id": 8,
        "title": "jobs",
        "parent_id": 0,
        "subheader": "dashboard",
        "path": "paths.dashboard.jobs.root",
        "icon": "ic_job",
        "priority": 8,
        "permission": "jobs"
    },
    {
        "id": 13,
        "title": "talents",
        "parent_id": 0,
        "subheader": "dashboard",
        "path": "paths.dashboard.talent.root",
        "icon": "ic_user",
        "priority": 10,
        "permission": "profiles"
    },
    {
        // Read-only audit view of talent offers platform-wide.
        // Dedicated permission — grant via Admin edit page to limit who
        // can audit the financial trail across every workspace.
        "id": 50,
        "title": "Talent Offers",
        "parent_id": 0,
        "subheader": "dashboard",
        "path": "paths.dashboard.talentOffers.root",
        "icon": "ic_invoice",
        "priority": 11,
        "permission": "talentOffers"
    },
    {
        "id": 52,
        "title": "Representation Agreements",
        "parent_id": 0,
        "subheader": "dashboard",
        "path": "paths.dashboard.representationAgreements.root",
        "icon": "ic_file",
        "priority": 12,
        "permission": "representationAgreements"
    },
    {
        // Read-only chat-monitoring surface for the CRM 1:1 chats.
        "id": 51,
        "title": "Chats",
        "parent_id": 0,
        "subheader": "dashboard",
        "path": "paths.dashboard.chats.root",
        "icon": "ic_chat",
        "priority": 46,
        "permission": "chats"
    },
    {
      "id": 14,
      "title": "leads",
      "parent_id": 0,
      "subheader": "dashboard",
      "path": "paths.dashboard.leads.root",
      "icon": "ic_user",
      "priority": 12,
      "permission": "leads"
    },
    {
      "id": 17,
      "title": "agencies",
      "parent_id": 0,
      "subheader": "dashboard",
      "path": "paths.dashboard.agency.root",
      "icon": "ic_user",
      "priority": 16,
      "permission": "agencies"
    },
    {
      "id": 24,
      "title": "talent Types",
      "parent_id": 0,
      "subheader": "management",
      "path": "paths.dashboard.talentTypes.root",
      "icon": "ic_product",
      "priority": 18,
      "permission": "talentTypes"
    },
    {
      "id": 19,
      "title": "Locations",
      "parent_id": 0,
      "subheader": "dashboard",
      "path": "paths.dashboard.locations.root",
      "icon": "ic_location",
      "priority": 19,
      "permission": "locations"
    },
    {
      "id": 20,
      "title": "proposals",
      "parent_id": 0,
      "subheader": "dashboard",
      "path": "paths.dashboard.proposals.root",
      "icon": "ic_folder",
      "priority": 20,
      "permission": "proposals"
    },
    {
      "id": 21,
      "title": "Equipments",
      "parent_id": 0,
      "subheader": "dashboard",
      "path": "paths.dashboard.equipments.root",
      "icon": "ic_equipment",
      "priority": 21,
      "permission": "equipments"
    },
    {
      "id": 22,
      "title": "Auditions",
      "parent_id": 0,
      "subheader": "dashboard",
      "path": "paths.dashboard.auditions.root",
      "icon": "ic_audition",
      "priority": 22,
      "permission": "auditions"
    },
    {
      "id": 23,
      "title": "Clients",
      "parent_id": 0,
      "subheader": "dashboard",
      "path": "paths.dashboard.clients.root",
      "icon": "ic_client",
      "priority": 23,
      "permission": "clients"
    },
    {
      "id": 25,
      "title": "Geo",
      "parent_id": 0,
      "subheader": "management",
      "path": "paths.dashboard.geo.root",
      "icon": "ic_location",
      "priority": 25,
      "permission": "geo"
    },
    {
      "id": 26,
      "title": "Countries",
      "parent_id": 25,
      "subheader": "management",
      "path": "paths.dashboard.geo.countries",
      "icon": "",
      "priority": 26,
      "permission": "geo"
    },
    {
      "id": 27,
      "title": "States",
      "parent_id": 25,
      "subheader": "management",
      "path": "paths.dashboard.geo.states",
      "icon": "",
      "priority": 27,
      "permission": "geo"
    },
    {
      "id": 28,
      "title": "Cities",
      "parent_id": 25,
      "subheader": "management",
      "path": "paths.dashboard.geo.cities",
      "icon": "",
      "priority": 28,
      "permission": "geo"
    },
    {
      "id": 29,
      "title": "Tax Rates",
      "parent_id": 25,
      "subheader": "management",
      "path": "paths.dashboard.geo.taxRates",
      "icon": "",
      "priority": 29,
      "permission": "geo"
    },
    {
      "id": 30,
      "title": "Services",
      "parent_id": 0,
      "subheader": "management",
      "path": "paths.dashboard.services.root",
      "icon": "ic_product",
      "priority": 30,
      "permission": "services"
    },
    {
      "id": 31,
      "title": "Languages",
      "parent_id": 0,
      "subheader": "management",
      "path": "paths.dashboard.languages.root",
      "icon": "ic_label",
      "priority": 31,
      "permission": "languages"
    },
    {
      "id": 32,
      "title": "Contact Forms",
      "parent_id": 0,
      "subheader": "management",
      "path": "paths.dashboard.contactForms.root",
      "icon": "ic_mail",
      "priority": 32,
      "permission": "contactForms"
    },
    {
      "id": 33,
      "title": "Testimonials",
      "parent_id": 0,
      "subheader": "management",
      "path": "paths.dashboard.testimonials.root",
      "icon": "ic_chat",
      "priority": 33,
      "permission": "testimonials"
    },
    {
      "id": 34,
      "title": "Contracts",
      "parent_id": 0,
      "subheader": "management",
      "path": "paths.dashboard.contracts.root",
      "icon": "ic_file",
      "priority": 34,
      "permission": "contracts"
    },
    {
      "id": 35,
      "title": "Shared Media",
      "parent_id": 0,
      "subheader": "dashboard",
      "path": "paths.dashboard.sharedMedia.root",
      "icon": "ic_external",
      "priority": 35,
      "permission": "sharedMedia"
    },
    {
      "id": 36,
      "title": "Access Requests",
      "parent_id": 0,
      "subheader": "dashboard",
      "path": "paths.dashboard.accessRequests.root",
      "icon": "ic_lock",
      "priority": 36,
      "permission": "accessRequests"
    },
    {
      "id": 37,
      "title": "Projects",
      "parent_id": 0,
      "subheader": "dashboard",
      "path": "paths.dashboard.projects.root",
      "icon": "ic_kanban",
      "priority": 37,
      "permission": "projects"
    },
    {
      "id": 38,
      "title": "AI",
      "parent_id": 0,
      "subheader": "management",
      "path": "paths.dashboard.ai.root",
      "icon": "ic_chat",
      "priority": 38,
      "permission": "ai"
    },
    {
      "id": 39,
      "title": "Campaigns",
      "parent_id": 0,
      "subheader": "dashboard",
      "path": "paths.dashboard.campaigns.root",
      "icon": "ic_mail",
      "priority": 39,
      "permission": "campaigns"
    },
    {
      "id": 40,
      "title": "Email",
      "parent_id": 39,
      "subheader": "dashboard",
      "path": "paths.dashboard.campaigns.email",
      "icon": "",
      "priority": 40,
      "permission": "campaigns.email"
    },
    {
      "id": 41,
      "title": "WhatsApp",
      "parent_id": 39,
      "subheader": "dashboard",
      "path": "paths.dashboard.campaigns.whatsapp",
      "icon": "",
      "priority": 41,
      "permission": "campaigns.whatsapp"
    },
    {
      "id": 61,
      "title": "Campaign Leads",
      "parent_id": 39,
      "subheader": "dashboard",
      "path": "paths.dashboard.campaigns.leads",
      "icon": "",
      "priority": 42,
      "permission": "campaigns.whatsapp"
    },
    {
      // AI likeness licensing — staff price talent opt-ins (which makes them
      // live), publish the consent/licence wording and maintain the standard
      // package. Same `users` permission the backend checks.
      "id": 63,
      "title": "AI Likeness",
      "parent_id": 0,
      "subheader": "dashboard",
      "path": "paths.dashboard.likeness.root",
      "icon": "ic_lock",
      "priority": 13,
      "permission": "users"
    },
    {
      "id": 64,
      "title": "Opt-ins",
      "parent_id": 63,
      "subheader": "dashboard",
      "path": "paths.dashboard.likeness.optIns",
      "icon": "",
      "priority": 14,
      "permission": "users"
    },
    {
      "id": 65,
      "title": "Terms",
      "parent_id": 63,
      "subheader": "dashboard",
      "path": "paths.dashboard.likeness.terms",
      "icon": "",
      "priority": 15,
      "permission": "users"
    },
    {
      "id": 66,
      "title": "Package",
      "parent_id": 63,
      "subheader": "dashboard",
      "path": "paths.dashboard.likeness.package",
      "icon": "",
      "priority": 16,
      "permission": "users"
    },
    {
      "id": 67,
      "title": "Requests",
      "parent_id": 63,
      "subheader": "dashboard",
      "path": "paths.dashboard.likeness.requests",
      "icon": "",
      "priority": 17,
      "permission": "users"
    },
    {
      "id": 62,
      "title": "Account Deletions",
      "parent_id": 0,
      "subheader": "dashboard",
      "path": "paths.dashboard.accountDeletions.root",
      "icon": "ic_lock",
      "priority": 53,
      "permission": "accountDeletions"
    },
    {
      "id": 42,
      "title": "Bookings",
      "parent_id": 0,
      "subheader": "dashboard",
      "path": "paths.dashboard.bookings.root",
      "icon": "ic_calendar",
      "priority": 42,
      "permission": "bookings"
    },
    {
      "id": 55,
      "title": "Job Leads",
      "parent_id": 0,
      "subheader": "dashboard",
      "path": "paths.dashboard.jobLeads.root",
      "icon": "ic_analytics",
      "priority": 47,
      "permission": "jobLeads"
    },
    {
      "id": 56,
      "title": "Leads",
      "parent_id": 55,
      "subheader": "dashboard",
      "path": "paths.dashboard.jobLeads.list",
      "icon": "",
      "priority": 48,
      "permission": "jobLeads.leads"
    },
    {
      "id": 57,
      "title": "Scrape Jobs",
      "parent_id": 55,
      "subheader": "dashboard",
      "path": "paths.dashboard.jobLeads.brightData",
      "icon": "",
      "priority": 49,
      "permission": "jobLeads.brightData"
    },
    {
      "id": 58,
      "title": "Services & Leads",
      "parent_id": 0,
      "subheader": "dashboard",
      "path": "paths.dashboard.serviceLeads.root",
      "icon": "ic_product",
      "priority": 50,
      "permission": "serviceLeads"
    },
    {
      "id": 59,
      "title": "Film Production",
      "parent_id": 0,
      "subheader": "production",
      "path": "paths.dashboard.filmMonitor.root",
      "icon": "ic_kanban",
      "priority": 51,
      "permission": "film"
    },
    {
      "id": 60,
      "title": "Voices",
      "parent_id": 0,
      "subheader": "production",
      "path": "paths.dashboard.voices.root",
      "icon": "ic_audition",
      "priority": 52,
      "permission": "voices"
    },
];
  const { hasPermission } = useAuthContext();

  // Filter menu items by permission
  const filteredMenu = menu.filter(item => hasPermission(item.permission));

  const subheader = [];
  for(var m=0;m<filteredMenu.length;m++){
    let _sh = subheader.filter(s=>s.subheader == t(filteredMenu[m]['subheader']));
    const path_arr = filteredMenu[m]['path'].split('.');
    let _path = paths;
      for(var p=1;p<path_arr.length;p++){
        if(_path[path_arr[p]])
        _path = _path[path_arr[p]];
        else{
          _path='/404';
          break;
        }
      }
    if(_sh.length>0){
      if(filteredMenu[m].parent_id == 0){
        _sh[0].items.push({
          id:filteredMenu[m].id, title: t(filteredMenu[m]['title']), path: _path, icon: icon(filteredMenu[m].icon)
        })
      }else{
        for(var i=0; i<_sh[0].items.length;i++){
          if(_sh[0].items[i].id == filteredMenu[m].parent_id){
            if('children' in _sh[0].items[i])
              _sh[0].items[i].children.push({id:filteredMenu[m].id,title: t(filteredMenu[m]['title']), path: _path})
            else
            _sh[0].items[i]['children'] = [{id:filteredMenu[m].id,title: t(filteredMenu[m]['title']), path: _path}];
          }
        }
      }
    }else{
      subheader.push({
        subheader: t(filteredMenu[m]['subheader']),
        items: [
          { id:filteredMenu[m].id,title: t(filteredMenu[m]['title']), path: _path, icon: icon(filteredMenu[m].icon) }
        ]
      })
    }
  }

  // Remove empty subheader groups
  const filteredSubheader = subheader.filter(group => group.items.length > 0);

  const data = useMemo(
    () => filteredSubheader,[t, filteredSubheader]
  );

  return data;
}
